class MuteService {
    constructor($rootScope, $log, $timeout, wtcpjsClientProviderService, persistenceService) {
        this.$rootScope = $rootScope;
        this.$log = $log;
        this.$timeout = $timeout;
        this.clientFactory = wtcpjsClientProviderService.getClient;
        this.persistenceService = persistenceService;
        this.tempMuteChannels = [];
        
        // 'true' == muted
        this.channelMuteStatusMap = {};

        var onChannelsUpdated = $rootScope.$on('channelModel.channelsUpdated', (event, data) => this.updateChannels(data));
        var onActiveChannelsChanged = $rootScope.$on('wtcpjsService.activeChannelsChanged', (event, activeChannelList) => this.muteSavedChannels() );

        // unmute channel if PTT started on the channel
        var onPttStarted = $rootScope.$on('pttStarted', (event, channelId) => {
            if (this.getMuteStatus(channelId))
                this.toggleMute(channelId);
        });

        $rootScope.$on('$destroy', () => {
            onChannelsUpdated();
            onPttStarted();
            onActiveChannelsChanged();
        });
    }

    muteSavedChannels() {
        let savedMutedChannels = this.persistenceService.getUserProfileServerValue('mutedChannelIds');

        if(savedMutedChannels)
            for (let id of savedMutedChannels)
                this.channelMuteStatusMap[id] = true;

        var channels = this.getMutedChannels();

        if (channels.length > 0) {
            this._sendMutedChannelIds(channels).then(() => {
                this.$log.debug('Activating audio player, muted channels after reconnect', channels);
                this.$timeout(() => this.clientFactory().AudioPlayerActive = true, 500);
            });
        }
        else {
            this.$log.debug('Activating audio player, no muted channels');
            this.clientFactory().AudioPlayerActive = true;
        }
    }

    updateChannels(channels) {
        for (let channelId in channels) {
            if(channels.hasOwnProperty(channelId))
                this.channelMuteStatusMap[channelId] = false;
        }
        this.$log.debug(`updating mute status for channels - `, channels);
    }

    getMuteStatus(channelId) {
        if (channelId === undefined)
            return this.channelMuteStatusMap;
        else
            return this.channelMuteStatusMap[channelId];
    }

    toggleMute(channelId) {
        this.channelMuteStatusMap[channelId] = !this.channelMuteStatusMap[channelId];
        let mutedChannelIds = this.getMutedChannels();
        this._saveAndSendMutedChannel(mutedChannelIds);
    }

    getMutedChannels() {
        // grab the array of muted channel Ids
        return Object
            .keys(this.channelMuteStatusMap)
            .filter((x) => this.channelMuteStatusMap[x])
            .map((x) => parseInt(x));
    }
    
    tempMuteAll() {
        let mutedChannelIds = [];
        
        for (let channelId in this.channelMuteStatusMap) {
            if(!this.channelMuteStatusMap[channelId])
                this.tempMuteChannels.push(parseInt(channelId));
            
            mutedChannelIds.push(parseInt(channelId));
            this.channelMuteStatusMap[channelId] = true;
        }
        
        this.$log.debug(`mute un-muted channels - [${this.tempMuteChannels}]`);
        this._sendMutedChannelIds(mutedChannelIds);
    }
    
    restoreTempMute() {
        let mutedChannelIds = [];

        var indx = 0;
        for(let channelId in this.channelMuteStatusMap) {
            indx = this.tempMuteChannels.indexOf(parseInt(channelId));
            if(indx > -1) {
                this.channelMuteStatusMap[channelId] = false;
            } else
                mutedChannelIds.push(parseInt(channelId));
        }

        this.tempMuteChannels = [];

        this.$log.debug(`un-mute channels - [${this.tempMuteChannels}]`);
        this._sendMutedChannelIds(mutedChannelIds);
    }
    
    muteAll() {
        let mutedChannelIds = [];

        for (let channelId in this.channelMuteStatusMap) {
            mutedChannelIds.push(parseInt(channelId));
            this.channelMuteStatusMap[channelId] = true;
        }

        this._saveAndSendMutedChannel(mutedChannelIds);
    }

    unmuteAll() {
        for (let channelId in this.channelMuteStatusMap) {
            this.channelMuteStatusMap[channelId] = false;
        }

        this.$log.debug('unmute all');
        this._saveAndSendMutedChannel([]);
    }

    allChannelsMuted() {
        let keys = Object.keys(this.channelMuteStatusMap);
        if (keys.length === 0)
            return false;
        else
            return Object.keys(this.channelMuteStatusMap).every((id) => this.channelMuteStatusMap[id]);
    }

    _saveAndSendMutedChannel(mutedChannelIds) {
        this.persistenceService.setUserProfileServerValue('mutedChannelIds', mutedChannelIds);
        this._sendMutedChannelIds(mutedChannelIds);
    }

    _sendMutedChannelIds(mutedChannelIds) {
        this.$log.debug('muted channels: ' + mutedChannelIds);
        return this.clientFactory().muteChannels(mutedChannelIds);
    }
}

angular.module('webcomm').service('muteService', ['$rootScope', '$log', '$timeout', 'wtcpjsClientProviderService', 'persistenceService', MuteService]);